// PW TOOLS JS FRONT
window.showMessage = showMessage
window.popup = popup
window.toggleSidebar = toggleSidebar
window.scrollToGo = scrollToGo
window.copy = copy
window.checkPasswordStrength = checkPasswordStrength
window.inputFile = inputFile

// Fonction input file
function inputFile(selector = '.input-file') {
    $(selector).each(function() {
        let fileInput = $(this).find('input[type="file"]');

        fileInput.on('change', function(event) {
            let this_return = $(this).next().next();
            this_return.html($(this).val().replace('C:\\fakepath\\', ' '));
        });
    });
}

// Fonction qui affiche une notification en bas du header pendant 3 secondes
// type : ( string ) class qu'aura l'élément ajouté ( success, error ou delete )
// message : ( string ) message affiché
function showMessage(type, message) {
    var alert = $('<p>')
    alert.addClass('msg-info flash')
    alert.addClass(type)
    alert.html(message)

    $('body').append(alert)

    setTimeout(function () {
        alert.addClass('open')
    }, 100)

    setTimeout(function () {
        alert.removeClass('open')
    }, 3000)

    setTimeout(function () {
        alert.remove()
    }, 3500)
}

// POPUP
function popup(pop) {
    $('body').addClass('mode-popup')
    pop.addClass('open')

    $(document).on('mouseup',function(e){
        if (!pop.is(e.target) && pop.has(e.target).length === 0)
        {
            pop.removeClass('open')
            $('body').removeClass('mode-popup')
        }
    });
}

// TOGGLE SIDEBAR
function toggleSidebar(sidebar) {
    if ($('.sidebar-toggle').hasClass("is-open")) {
        $('.sidebar-toggle').removeClass("is-open");
    }

    sidebar.toggleClass("is-open");

    $(document).mouseup(function (e) {
        if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0) {
            sidebar.removeClass('is-open')
        }
    });
}

function toggleSidebar(element) {
    let sidebar = $('#' + element)
    let btn = $('[data-toggle-sidebar="'+element+'"]')
    let nav = $('#main-menu')

    sidebar.toggleClass('is-open')
    btn.toggleClass('actif')

    if( nav.hasClass("showing-nav") ) {
        $('.js-toggle-nav').removeClass('menu-open')
        nav.removeClass("showing-nav")
        $('.js-toggle-nav').attr('aria-expanded','false')
    }

    // multi toggle-sidebar
    if($('.sidebar-toggle:not(#'+element+')').hasClass("is-open")) {
        $('.sidebar-toggle:not(#'+element+') [data-toggle-sidebar]').attr('aria-expanded','false')
        $('.sidebar-toggle:not(#'+element+') [data-toggle-sidebar]').removeClass('actif')
        $('.sidebar-toggle:not(#'+element+')').removeClass("is-open")
    }

    if(sidebar.hasClass('is-open')) {
        btn.attr('aria-expanded','true')
    } else {
        btn.attr('aria-expanded','false');
    }
}

function closeSidebar(element) {
    let sidebar = $('#' + element)
    let btn = $('[data-toggle-sidebar="'+element+'"]')

    sidebar.removeClass('is-open')
    btn.attr('aria-expanded','false');
    btn.removeClass('actif');
}

function closeAllSidebar() {
    if($('.sidebar-toggle').hasClass("is-open")) {
        $('[data-toggle-sidebar]').attr('aria-expanded','false');
        $('[data-toggle-sidebar]').removeClass('actif');
        $('.sidebar-toggle').removeClass("is-open");
    }
}

// COPY FUNCTION
function copyLegacy(text) {
    let textArea = document.createElement("textarea")
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus({preventScroll: true})
    textArea.select()

    try {
        document.execCommand('copy')
        showMessage('success','texte copié !');

    } catch (err) {
        console.error('Copy error', err)
        showMessage('error','texte non copié !');
    }

    document.body.removeChild(textArea)
}

function copy(selector) {
    let textToCopy = selector.text()

    if (location.protocol === 'https:') {
        // marche uniquement en https
        navigator.clipboard.writeText(textToCopy).then(function() {
            showMessage('success','texte copié !');
        }, function() {
            showMessage('error','texte non copié !');
        });

    } else {
        copyLegacy(textToCopy)
    }
}

// SCROLL TO GO
function scrollToGo(selector) {
    if (selector.length) {
        if ($('sidebar-toggle').hasClass("is-open")) {
            $('.sidebar-toggle').removeClass("is-open");
        }

        $("html, body").animate({ scrollTop: $(selector).offset().top - ($('header').height()-1) }, 1000);
    }
    return false
}

function checkPasswordStrength(e) {
    let pwdMsg = $('.pwd-msg')
    let number = /([0-9])/;
    let alphabets = /([a-zA-Z])/;
    let special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
    let password = e.val().trim();

    if(password.length === 0) {
        pwdMsg.removeClass('error success warning');
        pwdMsg.html("14 caractères minimum, lettres, chiffres et caractères spéciaux");

    } else {
        if (password.length < 14) {
            pwdMsg.removeClass('error success warning');
            pwdMsg.addClass('error');
            pwdMsg.html("Votre mot de passe doit faire au moins 14 caractères");
        } else {
            if (password.match(number) && password.match(alphabets) && password.match(special_characters)) {
                pwdMsg.removeClass('error success warning');
                pwdMsg.addClass('success');
                pwdMsg.html("Votre mot de passe est acceptable");
            }
            else {
                pwdMsg.removeClass('error success warning');
                pwdMsg.addClass('warning');
                pwdMsg.html("Votre mot de passe doit inclure des lettres, des nombres et des caractères spéciaux");
            }
        }
    }
}

$(document).ready(function () {
    // INPUT FILE
    inputFile()

    // RETOUR EN HAUT - créer balise #gotop
    $('#gotop').on('click', function () {
        //
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        return false
    })

     // BOUTON TOGGLE MAIN NAV
    $('.js-toggle-nav').on('click', function () {
        let nav = $('#main-menu');

        $(this).toggleClass('menu-open')
        $(this).removeAttr('aria-expanded')

        if($(this).hasClass('menu-open')) {
            $(this).attr('aria-expanded','true')
            nav.addClass('showing-nav')

        } else {
            $(this).attr('aria-expanded','false');
            nav.removeClass('showing-nav')
        }

        // CLOSE SIDEBAR TOGGLE
        //closeAllSidebar()

        return false
    })

    // TOGGLE SIDEBAR
    $('body').on('click', '[data-toggle-sidebar]', function () {
        toggleSidebar($(this).attr('data-toggle-sidebar'))
    });

    // CLOSE SIDEBAR
    $('body').on('click', '[data-close-sidebar]', function () {
        closeSidebar($(this).attr('data-close-sidebar'))
    })

    // BOUTON TOGGLE SEARCH
    $('.toggle-search').on('click', function () {
        $(this).toggleClass('search-mobile-on')
        $('.form-search').toggleClass('search-open')
        return false
    })

    // SCROLL TO
    $('a[href^="#"]').on('click', function() {
        let selector = $(this).attr('href')
        scrollToGo(selector)
    })

    // TOGGLE SIDEBAR
    $('[data-toggle-sidebar]').on('click', function () {
        let sidebar = $('#' + $(this).attr('data-toggle-sidebar'))
        toggleSidebar(sidebar)
    });

    // CLOSE TOGGLE
    $('.js-close-toggle').on('click', function () {
        $(this).parents('.sidebar-toggle').removeClass('is-open')
    })

    // COPY JS
    $('[data-copy]').on('click', function() {
        let copyTarget = $('#' + $(this).attr('data-copy'))
        copy(copyTarget)
    });

    // POPUP
    $('[data-popup]').on('click', function () {
        let pop = $('#' + $(this).attr('data-popup'))
        popup(pop)
    });

    $('.close-popup').on('click', function () {
        $('body').removeClass('mode-popup')
        $(this).parent('.popup').removeClass('open')
    })

    // ONGLETS
    $('[data-onglet]').on('click', function () {
        $('[data-onglet]').removeClass('actif')
        $('.onglet-content').removeClass('open')
        $(this).addClass('actif')
        $('#' + $(this).attr('data-onglet')).addClass('open')
    })

    // TOGGLE SECTION
    $('.toggle-item').on('click', '> .toggle-launcher', function () {
        if ($(this).parent().hasClass('open')) {
            $(this).parent().removeClass('open')
        } else {
            $('.toggle-section .toggle-item.open').removeClass('open')
            $(this).parent().addClass('open')
        }

        return false
    })

    // RECUP EMAIL NEWSLETTER POPUP
    $('[data-popup-news="inscrinews"]').on('click', function () {
        if ($('#recup-email-news:success').length != 0) {
            var email = $('#recup-email-news').val()
            $('#email-newsletter').attr('value', email)
            $('body').addClass('mode-popup')
            $('#' + $(this).attr('data-popup-news')).addClass('open')
        }
    })

    //Select custom :
    $('.select-custom select').each(function () {
        const dropdown = $('<div />').addClass('dropdown selectDropdown')

        $(this).wrap(dropdown)

        const label = $('<span />').text($(this).attr('placeholder')).insertAfter($(this))
        const list = $('<ul class="list-select" />')

        $(this)
            .find('option')
            .each(function () {
                list.append($('<li />').append($('<a />').text($(this).text())))
            })

        list.insertAfter($(this))

        if ($(this).find('option:selected').length) {
            label.text($(this).find('option:selected').text())
            list.find('li:contains(' + $(this).find('option:selected').text() + ')').addClass('active')
            $(this).parent().addClass('filled')
        }
    })

    $(document).on('click touch', '.selectDropdown ul li a', function (e) {
        e.preventDefault()
        const dropdown = $(this).parent().parent().parent()
        const active = $(this).parent().hasClass('active')
        const label = active ? dropdown.find('select').attr('placeholder') : $(this).text()

        dropdown.find('option').prop('selected', false)
        dropdown.find('ul li').removeClass('active')

        dropdown.toggleClass('filled', !active)
        dropdown.children('span').text(label)

        if (!active) {
            dropdown.find('option:contains(' + $(this).text() + ')').prop('selected', true)
            $(this).parent().addClass('active')
        }

        dropdown.removeClass('open')
    })

    $('.dropdown > span').on('click touch', function (e) {
        const self = $(this).parent()
        self.toggleClass('open')
    })

    $(document).on('click touch', function (e) {
        const dropdown = $('.dropdown')
        if (dropdown !== e.target && !dropdown.has(e.target).length) {
            dropdown.removeClass('open')
        }
    })

    $('.link-to-go').click(function (event) {
        event.preventDefault()
        let url = $(this).attr('data-href')
        window.open(url)
    })

}) // FIN DOCUMENT READY
